const actions = {
  INVENTORY_TRANSFER: "INVENTORY_TRANSFER",
  INVENTORY_TRANSFER_SUCCESS: "INVENTORY_TRANSFER_SUCCESS",
  INVENTORY_TRANSFER_FAILED: "INVENTORY_TRANSFER_FAILED",

  RESET_MESSAGE: 'RESET_MESSAGE',


  inventoryTransferReq: (data) => ({
    type: actions.INVENTORY_TRANSFER,
    payload: { data },
  }),
  inventoryTransferSuccess: (message) => ({
    type: actions.INVENTORY_TRANSFER_SUCCESS,
    message
  }),
  inventoryTransferError: (error, fResult) => ({
    type: actions.INVENTORY_TRANSFER_FAILED,
    payload: { error, fResult },
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),

};
export default actions;
